// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
// Pure placement policy shared by Builder and the renderers; no mesh/runtime imports.
import type {MachineDefinition,MachineLamp} from '@core/machine'
/** Clamp to the real32mm upper-wall crown; the entire fixture stays above the rolling ball. */
export function flasherMountFits(d:MachineDefinition,lamp:MachineLamp):boolean{
 if(d.colliders.some(c=>c.id===lamp.id+'Base'&&c.kind==='circle'))return false
 const p=lamp.position,r=(lamp.radius??.024)*.027/.026,board=d.dimensions.playfield
 const wall=d.colliders.find(c=>c.id==='wallTop')
 return p!==undefined&&r>0&&Number.isFinite(r)&&wall?.kind==='segment'&&wall.device===undefined&&wall.material==='metal'&&Math.abs(wall.a[1]-wall.b[1])<1e-9
  &&p[0]-r>=Math.min(wall.a[0],wall.b[0])&&p[0]+r<=Math.max(wall.a[0],wall.b[0])
  &&wall.a[1]-p[1]>=.035&&wall.a[1]-p[1]<=.065&&p[1]+r<wall.a[1]-.003&&p[1]-r>-board.length/2&&.080<d.dimensions.glassHeight
}

export const flasherFloorHeightScale=(radius:number):number=>Math.min(1,Math.max(.75,radius/.026))
